import { z } from 'zod'

const cVStepPrivacyPolicySchema = z.object({
  privacyAccept: z.boolean()
})

export default cVStepPrivacyPolicySchema
